import React from "react";
import { FluentProvider, makeStyles, tokens, Button, Tooltip } from "@fluentui/react-components";
import { NavigationRegular } from "@fluentui/react-icons";
import { observer } from "owa-mobx-react";
import type { ToggleButtonProps } from "./ToggleButtonProps";

export const ToggleButton: React.FunctionComponent<ToggleButtonProps> = observer(({ label, onClick, disabled }: ToggleButtonProps) => {
    const { button, icon, provider } = useStyles();
    const navigationIcon = React.useMemo(() => <NavigationRegular className={icon}/>, [icon]);
    
    return (<FluentProvider className={provider}>
                <Tooltip content={label} positioning="below" relationship="label" withArrow={true}>
                    <Button appearance="transparent" className={button} icon={navigationIcon} onClick={onClick} disabled={disabled}/>
                </Tooltip>
            </FluentProvider>);
}, "ToggleButton");

const useStyles = makeStyles({
    button: {
        height: "32px",
        margin: "0 0 0 6px",
        maxWidth: "none",
        padding: "3px 9px",
        ":hover": {
            backgroundColor: tokens.colorNeutralBackground2Hover,
        },
    },
    icon: {
        color: tokens.colorNeutralForeground1,
        "@media (forced-colors: active)": {
            color: "CanvasText",
            ":hover": {
                color: "Highlight",
            },
        },
        fontWeight: tokens.fontWeightRegular,
    },
    provider: {
        backgroundColor: "transparent",
    },
});
